import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MunicipalityKeys } from '../models/municipality-list-row';

@Component({
  selector: 'app-municipality-onboarding-result-modal',
  templateUrl: './municipality-onboarding-result-modal.component.html',
  styleUrls: ['./municipality-onboarding-result-modal.component.scss'],
})
export class MunicipalityOnboardingResultModalComponent {
  showAdded = false;
  showInvalidSkipped = false;

  showAdded$: Observable<boolean> = of(this.onboardingKeys).pipe(map((data) => data.added.length > 0));
  showInvalidSkipped$: Observable<boolean> = of(this.onboardingKeys).pipe(map((data) => data.skipped.length > 0 || data.invalid.length > 0));

  constructor(
    @Inject(MAT_DIALOG_DATA) public onboardingKeys: MunicipalityKeys,
    private readonly dialogRef: MatDialogRef<MunicipalityOnboardingResultModalComponent>,
    public translate: TranslateService,
  ) {}

  /**
   * Close the dialog
   */
  closeModal(): void {
    this.dialogRef.close();
  }
}
